module.exports = __webpack_public_path__ + "static/img/2banner.7e08cd1.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/2banner.png
// module id = yiX6
// module chunks = 1